module.exports = __webpack_public_path__ + "static/media/img6.8aabf8a9.jpg";